import { LoadingIndicator } from 'app/components/LoadingIndicator';
import * as React from 'react';
import { lazyLoad } from 'utils/loadable';

export const AuditLogsHome = lazyLoad(
  () => import('./routes'),
  module => module.default,
  {
    fallback: <LoadingIndicator />,
  },
);
